export default __webpack_public_path__ + "static/5-15864033365549773130454300eb0599.png";